import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { authAPI } from '../services/api';
import { Mail, X, Loader2, CheckCircle } from 'lucide-react';
import { toast } from 'sonner';

export const EmailVerificationBanner = () => {
  const { user } = useAuth();
  const [sending, setSending] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [sent, setSent] = useState(false);

  // Don't show if user is verified, dismissed, or not logged in
  if (!user || user.email_verified || dismissed) {
    return null;
  }

  const handleResend = async () => {
    setSending(true);
    try {
      await authAPI.resendVerification(user.email);
      setSent(true);
      toast.success('Verification email sent! Please check your inbox.');
    } catch (error) {
      const message = error.response?.data?.detail || 'Failed to send verification email';
      toast.error(message);
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="bg-yellow-500/20 border-b border-yellow-500/30" data-testid="email-verification-banner">
      <div className="max-w-7xl mx-auto px-4 py-3">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <Mail className="w-5 h-5 text-yellow-400 flex-shrink-0" />
            <p className="text-sm text-yellow-200">
              {sent ? (
                <span className="flex items-center gap-2">
                  <CheckCircle className="w-4 h-4 text-green-400" />
                  Verification email sent! Check your inbox.
                </span>
              ) : (
                <>
                  Please verify your email address to access all features.
                  <span className="text-yellow-400 ml-1">Some features are restricted until verified.</span>
                </>
              )}
            </p>
          </div>
          
          <div className="flex items-center gap-2 flex-shrink-0">
            {!sent && (
              <button
                onClick={handleResend}
                disabled={sending}
                className="px-4 py-1.5 rounded-full bg-yellow-500 text-black text-sm font-semibold hover:bg-yellow-400 disabled:opacity-50 flex items-center gap-2"
                data-testid="resend-verification-btn"
              >
                {sending ? (
                  <>
                    <Loader2 className="w-4 h-4 animate-spin" />
                    Sending...
                  </>
                ) : (
                  'Resend Email'
                )}
              </button>
            )}
            <button
              onClick={() => setDismissed(true)}
              className="p-1 hover:bg-yellow-500/20 rounded"
              title="Dismiss"
            >
              <X className="w-4 h-4 text-yellow-400" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
